import React from 'react';
import {ControlGroup, FormGroup, NumericInput} from '@blueprintjs/core';

import {intervalValue} from '../utils';
import {OnChangeCallback} from './types';
import AdvancedOptions from './AdvancedOptions';

interface HourlyProps {
  interval: any;
  byHour: number[] | string[];
  weekdays: string[];
  onChange: OnChangeCallback;
}

export const Hourly = ({
  interval,
  byHour,
  weekdays,
  onChange,
}: HourlyProps) => {
  return (
    <>
      <ControlGroup fill={true} className="no-flex">
        <FormGroup
          label="Every"
          inline={true}>
          <NumericInput
            min={1}
            max={99}
            defaultValue={interval}
            onValueChange={onChange('interval', intervalValue)}/>
        </FormGroup>
        <span className="info-text"> hour(s)</span>
      </ControlGroup>
      <AdvancedOptions
        byHour={byHour}
        weekdays={weekdays}
        onChange={onChange}
      />
    </>
  );
};
